import React, { useCallback } from "react";
import useStream from "components/streams/hooks/useStream";
import Routes from "routing/Routes";
import { Link } from "components/common";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const DataLakeConnectorStreamCell = ({ stream_id }) => {
  const { data: stream } = useStream(stream_id, { enabled: !!stream_id, refetchInterval: 3e3 });
  const sendTelemetry = useSendTelemetry();
  const handleClick = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.CONNECTORS.STREAM_NAME_LINK_CLICKED, {});
  }, [sendTelemetry]);
  return /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Link, { to: Routes.stream_search(stream_id), onClick: handleClick }, stream == null ? void 0 : stream.title));
};
export default DataLakeConnectorStreamCell;
